import React from 'react';
import { ActionButton, Grid, repeat } from '@adobe/react-spectrum';
import { toCSSColor } from '@printu/geom';
import { getMarkerSizeRange, markerSizeLerp, } from 'app/views/components/editor/pickers/SizeIcon';
const SelectedValueStyles = { border: '2px solid white' };
export const SizesGrid = (props) => {
    const { color, size: currentSize, sizes, onSelect } = props;
    const sizeRange = getMarkerSizeRange(sizes);
    const commonStyle = {
        borderRadius: '10%',
        backgroundColor: toCSSColor(color),
        width: '100%',
    };
    return (React.createElement(Grid, { "data-test-id": "size-picker", columns: repeat(sizes.length, 'size-400'), autoRows: "size-400", justifyContent: "stretch", gap: "size-100" }, sizes.map(size => {
        const markerHeightInPercents = markerSizeLerp(size, sizeRange).toFixed(2);
        return (React.createElement(ActionButton, { key: size, "data-test-id": `size-${size}`, onPress: () => onSelect(size), isQuiet: true },
            React.createElement("span", { style: Object.assign(Object.assign(Object.assign({}, commonStyle), { height: `${markerHeightInPercents}%` }), (size === currentSize &&
                    SelectedValueStyles)) }, "\u00A0")));
    })));
};
